module.exports = __webpack_public_path__ + "static/media/align-center.3f85015b.svg";